// src/store/pageNotFound.ts
import { create } from 'zustand';

type PageNotFoundState = {
  isFrom404Page: boolean;
  setIsFrom404Page: (value: boolean) => void;
};

export const pageNotFoundStore = create<PageNotFoundState>((set) => ({
  isFrom404Page: false,
  setIsFrom404Page: (value) => set({ isFrom404Page: value }),
}));
